import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';
import { ChefHat } from 'lucide-react';

const TodaysMenuCard = ({ menu, day, isServiceDay }) => {
  if (!isServiceDay) {
    return (
      <Card className="border border-gray-200 shadow-sm">
        <CardContent className="py-8 text-center text-gray-500">
          No service on weekends.
        </CardContent>
      </Card>
    );
  }

  if (!menu) {
    return (
      <Card className="border border-gray-200 shadow-sm">
        <CardContent className="py-8 text-center text-gray-500">
          No menu set for {day}.
        </CardContent>
      </Card>
    );
  }

  const meals = [
    { label: 'Breakfast', data: menu.breakfast, color: 'bg-amber-100 text-amber-800' },
    { label: 'Lunch', data: menu.lunch, color: 'bg-orange-100 text-orange-800' },
    { label: 'Dinner', data: menu.dinner, color: 'bg-indigo-100 text-indigo-800' },
    { label: 'Non-Veg Item', data: menu.nonveg_item, color: 'bg-red-100 text-red-800' },
    { label: 'Non-Veg Item 2', data: menu.nonveg_item_2, color: 'bg-red-100 text-red-800' },
  ];

  return (
    <Card className="border border-gray-200 shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold text-gray-800 flex items-center gap-2">
          <ChefHat className="h-5 w-5 text-orange-500" />
          Today's Menu — {day}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-5">
          {meals.map(({ label, data, color }) => (
            <div key={label} className="rounded-lg border border-gray-100 p-3">
              <Badge className={`${color} mb-2 text-xs`}>{label}</Badge>
              {data && data.name ? (
                <div>
                  <p className="font-semibold text-gray-900 text-sm">{data.name}</p>
                  {(data.protein > 0 || data.calories > 0) && (
                    <p className="text-xs text-gray-500 mt-1">
                      {data.protein > 0 && `${data.protein}g protein`}
                      {data.protein > 0 && data.calories > 0 && ' · '}
                      {data.calories > 0 && `${data.calories} cal`}
                    </p>
                  )}
                </div>
              ) : (
                <p className="text-sm text-gray-400 italic">Not set</p>
              )}
            </div>
          ))}
        </div>

        {(menu.instructions || menu.warnings) && (
          <div className="mt-3 flex flex-wrap gap-3">
            {menu.instructions && (
              <div className="text-xs text-gray-600 bg-gray-50 rounded p-2 flex-1">
                <span className="font-semibold">Instructions:</span> {menu.instructions}
              </div>
            )}
            {menu.warnings && (
              <div className="text-xs text-red-600 bg-red-50 rounded p-2 flex-1">
                <span className="font-semibold">Warnings:</span> {menu.warnings}
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TodaysMenuCard;
